import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import {
  Companion_getInstance13ujfby7pfhe7 as Companion_getInstance,
  toLocalDateTime2fafgh396r2y5 as toLocalDateTime,
  toInstant2ixtmlbww6j32 as toInstant,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_unpadded1ygmnwh0rw79t as get_unpadded } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  LocalDateTimeField29gd1oxpr4f6s as LocalDateTimeField,
  LocalDateField1854369auhx0q as LocalDateField,
  LocalTimeField1c574dxc0ggzd as LocalTimeField,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KProperty1ca4yb4wlo496 as KProperty1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { renderToStringprxvmjepz2st as renderToString } from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  priority2y7gf37j4tged as priority,
  cellView255m1dxiud5di as cellView,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { nowLocal3kwskrm67145u as nowLocal } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/ZonedDateTime.mjs';
import {
  renderToString20fhv3rgk9b94 as renderToString_0,
  renderToString2kyj9dlz89tdi as renderToString_1,
  renderToString1ghq9c47uw4e8 as renderToString_2,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerDateTimes(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.time.Instant'), InstantRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.time.Instant?'), NullableInstantRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.LocalDateTime'), LocalDateTimeRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.LocalDateTime?'), NullableLocalDateTimeRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.LocalDate'), LocalDateRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.LocalDate?'), NullableLocalDateRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.LocalTime'), LocalTimeRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.LocalTime?'), NullableLocalTimeRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.TimeZone'), TimeZoneRenderer_getInstance());
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlinx.datetime.TimeZone?'), NullableTimeZoneRenderer_getInstance());
}
function InstantRenderer$form$lambda$lambda(it) {
  return toLocalDateTime(it, Companion_getInstance().currentSystemDefault_9rduv_k$());
}
function InstantRenderer$form$lambda$lambda_0(old, new_0) {
  var tmp1_elvis_lhs = new_0 == null ? null : toInstant(new_0, Companion_getInstance().currentSystemDefault_9rduv_k$());
  return tmp1_elvis_lhs == null ? old : tmp1_elvis_lhs;
}
function InstantRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(System_instance.now_2cba_k$(), $completion);
    return Unit_instance;
  }), 1);
}
var InstantRendererClass;
function InstantRenderer() {
  if (InstantRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Date & Time';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_era96e_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalDateTimeField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          var tmp = InstantRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, InstantRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Now');
          element_1.set_action_2ds022_k$(Action('Now', VOID, VOID, VOID, VOID, VOID, InstantRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_era96e_k$(context, value, module_0);
      }
      view_yif4hr_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString($this$invoke.invoke_r7m7el_k$(value)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_yif4hr_k$(context, value, module_0);
      }
      cellForm_mtt8zw_k$(context, value, module_0) {
        return this.form_era96e_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_mtt8zw_k$(context, value, module_0);
      }
      columnWidth_dh1d1o_k$(context, module_0) {
        return 17.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_dh1d1o_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'InstantRenderer', VOID, VOID, [Renderer()]);
    InstantRendererClass = $;
  }
  return InstantRendererClass;
}
var InstantRenderer_instance;
function InstantRenderer_getInstance() {
  return InstantRenderer_instance;
}
function NullableInstantRenderer$form$lambda$lambda(it) {
  return it == null ? null : toLocalDateTime(it, Companion_getInstance().currentSystemDefault_9rduv_k$());
}
function NullableInstantRenderer$form$lambda$lambda_0(it) {
  return it == null ? null : toInstant(it, Companion_getInstance().currentSystemDefault_9rduv_k$());
}
function NullableInstantRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(System_instance.now_2cba_k$(), $completion);
    return Unit_instance;
  }), 1);
}
var NullableInstantRendererClass;
function NullableInstantRenderer() {
  if (NullableInstantRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Date & Time';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_gxo4yi_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalDateTimeField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          var tmp = NullableInstantRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_drj4fu_k$(tmp, NullableInstantRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Now');
          element_1.set_action_2ds022_k$(Action('Now', VOID, VOID, VOID, VOID, VOID, NullableInstantRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_gxo4yi_k$(context, value, module_0);
      }
      view_ma6wjf_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString(tmp0_safe_receiver);
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_ma6wjf_k$(context, value, module_0);
      }
      cellForm_hm3mw4_k$(context, value, module_0) {
        return this.form_gxo4yi_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_hm3mw4_k$(context, value, module_0);
      }
      columnWidth_6dhajt_k$(context, module_0) {
        return 17.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_6dhajt_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableInstantRenderer', VOID, VOID, [Renderer()]);
    NullableInstantRendererClass = $;
  }
  return NullableInstantRendererClass;
}
var NullableInstantRenderer_instance;
function NullableInstantRenderer_getInstance() {
  return NullableInstantRenderer_instance;
}
function LocalDateTimeRenderer$form$lambda$lambda(it) {
  return it;
}
function LocalDateTimeRenderer$form$lambda$lambda_0(old, new_0) {
  return new_0 == null ? old : new_0;
}
function LocalDateTimeRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(nowLocal(System_instance).dateTime_1, $completion);
    return Unit_instance;
  }), 1);
}
var LocalDateTimeRendererClass;
function LocalDateTimeRenderer() {
  if (LocalDateTimeRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Date & Time';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_auft22_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalDateTimeField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          var tmp = LocalDateTimeRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, LocalDateTimeRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Now');
          element_1.set_action_2ds022_k$(Action('Now', VOID, VOID, VOID, VOID, VOID, LocalDateTimeRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_auft22_k$(context, value, module_0);
      }
      view_8vu385_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString_0($this$invoke.invoke_r7m7el_k$(value)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_8vu385_k$(context, value, module_0);
      }
      cellForm_hu8ie4_k$(context, value, module_0) {
        return this.form_auft22_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_hu8ie4_k$(context, value, module_0);
      }
      columnWidth_u16kh_k$(context, module_0) {
        return 17.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_u16kh_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'LocalDateTimeRenderer', VOID, VOID, [Renderer()]);
    LocalDateTimeRendererClass = $;
  }
  return LocalDateTimeRendererClass;
}
var LocalDateTimeRenderer_instance;
function LocalDateTimeRenderer_getInstance() {
  return LocalDateTimeRenderer_instance;
}
function NullableLocalDateTimeRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(nowLocal(System_instance).dateTime_1, $completion);
    return Unit_instance;
  }), 1);
}
var NullableLocalDateTimeRendererClass;
function NullableLocalDateTimeRenderer() {
  if (NullableLocalDateTimeRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Date & Time';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_hzzb7e_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalDateTimeField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          element_0.bind_gesskf_k$(element_0.content_1, value);
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Now');
          element_1.set_action_2ds022_k$(Action('Now', VOID, VOID, VOID, VOID, VOID, NullableLocalDateTimeRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_hzzb7e_k$(context, value, module_0);
      }
      view_w2is1r_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString_0(tmp0_safe_receiver);
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_w2is1r_k$(context, value, module_0);
      }
      cellForm_8chlms_k$(context, value, module_0) {
        return this.form_hzzb7e_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_8chlms_k$(context, value, module_0);
      }
      columnWidth_ua40do_k$(context, module_0) {
        return 17.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_ua40do_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableLocalDateTimeRenderer', VOID, VOID, [Renderer()]);
    NullableLocalDateTimeRendererClass = $;
  }
  return NullableLocalDateTimeRendererClass;
}
var NullableLocalDateTimeRenderer_instance;
function NullableLocalDateTimeRenderer_getInstance() {
  return NullableLocalDateTimeRenderer_instance;
}
function LocalDateRenderer$form$lambda$lambda(it) {
  return it;
}
function LocalDateRenderer$form$lambda$lambda_0(old, new_0) {
  return new_0 == null ? old : new_0;
}
function LocalDateRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(nowLocal(System_instance).get_date_wokkxj_k$(), $completion);
    return Unit_instance;
  }), 1);
}
var LocalDateRendererClass;
function LocalDateRenderer() {
  if (LocalDateRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Date';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_9a1xoa_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalDateField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          var tmp = LocalDateRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, LocalDateRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Today');
          element_1.set_action_2ds022_k$(Action('Today', VOID, VOID, VOID, VOID, VOID, LocalDateRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_9a1xoa_k$(context, value, module_0);
      }
      view_5d7o1_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString_1($this$invoke.invoke_r7m7el_k$(value)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_5d7o1_k$(context, value, module_0);
      }
      cellForm_h305xg_k$(context, value, module_0) {
        return this.form_9a1xoa_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_h305xg_k$(context, value, module_0);
      }
      columnWidth_1gycek_k$(context, module_0) {
        return 11.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_1gycek_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'LocalDateRenderer', VOID, VOID, [Renderer()]);
    LocalDateRendererClass = $;
  }
  return LocalDateRendererClass;
}
var LocalDateRenderer_instance;
function LocalDateRenderer_getInstance() {
  return LocalDateRenderer_instance;
}
function NullableLocalDateRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(nowLocal(System_instance).get_date_wokkxj_k$(), $completion);
    return Unit_instance;
  }), 1);
}
var NullableLocalDateRendererClass;
function NullableLocalDateRenderer() {
  if (NullableLocalDateRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Date';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_ugz7ts_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalDateField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          element_0.bind_gesskf_k$(element_0.content_1, value);
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Today');
          element_1.set_action_2ds022_k$(Action('Today', VOID, VOID, VOID, VOID, VOID, NullableLocalDateRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_ugz7ts_k$(context, value, module_0);
      }
      view_yuwxjz_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString_1(tmp0_safe_receiver);
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_yuwxjz_k$(context, value, module_0);
      }
      cellForm_h3zftq_k$(context, value, module_0) {
        return this.form_ugz7ts_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_h3zftq_k$(context, value, module_0);
      }
      columnWidth_uplakf_k$(context, module_0) {
        return 11.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_uplakf_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableLocalDateRenderer', VOID, VOID, [Renderer()]);
    NullableLocalDateRendererClass = $;
  }
  return NullableLocalDateRendererClass;
}
var NullableLocalDateRenderer_instance;
function NullableLocalDateRenderer_getInstance() {
  return NullableLocalDateRenderer_instance;
}
function LocalTimeRenderer$form$lambda$lambda(it) {
  return it;
}
function LocalTimeRenderer$form$lambda$lambda_0(old, new_0) {
  return new_0 == null ? old : new_0;
}
function LocalTimeRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(nowLocal(System_instance).get_time_wouyhi_k$(), $completion);
    return Unit_instance;
  }), 1);
}
var LocalTimeRendererClass;
function LocalTimeRenderer() {
  if (LocalTimeRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Time';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_djr97q_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localTimeField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalTimeField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          var tmp = LocalTimeRenderer$form$lambda$lambda;
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, LocalTimeRenderer$form$lambda$lambda_0));
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Now');
          element_1.set_action_2ds022_k$(Action('Now', VOID, VOID, VOID, VOID, VOID, LocalTimeRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_djr97q_k$(context, value, module_0);
      }
      view_9bapan_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString_2($this$invoke.invoke_r7m7el_k$(value)));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_9bapan_k$(context, value, module_0);
      }
      cellForm_v4ap5o_k$(context, value, module_0) {
        return this.form_djr97q_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_v4ap5o_k$(context, value, module_0);
      }
      columnWidth_18hucz_k$(context, module_0) {
        return 6.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_18hucz_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'LocalTimeRenderer', VOID, VOID, [Renderer()]);
    LocalTimeRendererClass = $;
  }
  return LocalTimeRendererClass;
}
var LocalTimeRenderer_instance;
function LocalTimeRenderer_getInstance() {
  return LocalTimeRenderer_instance;
}
function NullableLocalTimeRenderer$form$lambda$slambda($value) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $value.set_revjhg_k$(nowLocal(System_instance).get_time_wouyhi_k$(), $completion);
    return Unit_instance;
  }), 1);
}
var NullableLocalTimeRendererClass;
function NullableLocalTimeRenderer() {
  if (NullableLocalTimeRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Time';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_hahzfm_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp$ret$0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_0 = get_unpadded(tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          var this_1 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.direct.localTimeField' call
          var this_2 = themed(this_1, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (LocalTimeField())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_2.willAddChild_hz2iwc_k$(element_0);
          element_0.bind_gesskf_k$(element_0.content_1, value);
          element_0.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          var this_3 = themed(element, ForcePaddingSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (Button())(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_3.willAddChild_hz2iwc_k$(element_1);
          text(get_centered(element_1), 'Now');
          element_1.set_action_2ds022_k$(Action('Now', VOID, VOID, VOID, VOID, VOID, NullableLocalTimeRenderer$form$lambda$slambda(value)));
          element_1.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_hahzfm_k$(context, value, module_0);
      }
      view_k0bpkx_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : renderToString_2(tmp0_safe_receiver);
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_k0bpkx_k$(context, value, module_0);
      }
      cellForm_65new0_k$(context, value, module_0) {
        return this.form_hahzfm_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_65new0_k$(context, value, module_0);
      }
      columnWidth_htriu6_k$(context, module_0) {
        return 6.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_htriu6_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableLocalTimeRenderer', VOID, VOID, [Renderer()]);
    NullableLocalTimeRendererClass = $;
  }
  return NullableLocalTimeRendererClass;
}
var NullableLocalTimeRenderer_instance;
function NullableLocalTimeRenderer_getInstance() {
  return NullableLocalTimeRenderer_instance;
}
function _get_allTimeZones__4t4mtu($this) {
  var tmp0 = $this.allTimeZones$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('allTimeZones', 1, tmp, TimeZoneRenderer$_get_allTimeZones_$ref_qjvuo9(), null);
  return tmp0.get_value_j01efc_k$().value_1;
}
function TimeZoneRenderer$allTimeZones$delegate$lambda() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = Companion_getInstance().get_availableZoneIds_kceyfo_k$();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$2 = Companion_getInstance().of_5gnbr7_k$(item);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  return new (Constant())(_Constant___init__impl__v45mub(destination));
}
function TimeZoneRenderer$_get_allTimeZones_$ref_qjvuo9() {
  return constructCallableReference((p0) => new (Constant())(_get_allTimeZones__4t4mtu(p0)), 1, 0, 164);
}
function TimeZoneRenderer$form$lambda$lambda(it) {
  return it.get_id_kntnx8_k$();
}
var TimeZoneRendererClass;
function TimeZoneRenderer() {
  if (TimeZoneRendererClass === VOID) {
    class $ {
      constructor() {
        TimeZoneRenderer_instance = this;
        this.name_1 = 'Time Zone';
        var tmp = this;
        tmp.allTimeZones$delegate_1 = lazy(TimeZoneRenderer$allTimeZones$delegate$lambda);
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_7gw92y_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Select())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          var tmp = _get_allTimeZones__4t4mtu(TimeZoneRenderer_getInstance());
          element.bind_64a41i_k$(value, new (Constant())(tmp), TimeZoneRenderer$form$lambda$lambda);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_7gw92y_k$(context, value, module_0);
      }
      view_c2pkov_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).get_id_kntnx8_k$());
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_c2pkov_k$(context, value, module_0);
      }
      cellForm_srxcn8_k$(context, value, module_0) {
        return this.form_7gw92y_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_srxcn8_k$(context, value, module_0);
      }
      columnWidth_wdhbo4_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_wdhbo4_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'TimeZoneRenderer', VOID, VOID, [Renderer()]);
    TimeZoneRendererClass = $;
  }
  return TimeZoneRendererClass;
}
var TimeZoneRenderer_instance;
function TimeZoneRenderer_getInstance() {
  if (TimeZoneRenderer_instance === VOID)
    new (TimeZoneRenderer())();
  return TimeZoneRenderer_instance;
}
function _get_allTimeZones__4t4mtu_0($this) {
  var tmp0 = $this.allTimeZones$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('allTimeZones', 1, tmp, NullableTimeZoneRenderer$_get_allTimeZones_$ref_ep3qmw(), null);
  return tmp0.get_value_j01efc_k$().value_1;
}
function NullableTimeZoneRenderer$allTimeZones$delegate$lambda() {
  var tmp = listOf(null);
  // Inline function 'kotlin.collections.map' call
  var this_0 = Companion_getInstance().get_availableZoneIds_kceyfo_k$();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$2 = Companion_getInstance().of_5gnbr7_k$(item);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  return new (Constant())(_Constant___init__impl__v45mub(plus(tmp, destination)));
}
function NullableTimeZoneRenderer$_get_allTimeZones_$ref_ep3qmw() {
  return constructCallableReference((p0) => new (Constant())(_get_allTimeZones__4t4mtu_0(p0)), 1, 0, 165);
}
function NullableTimeZoneRenderer$form$lambda$lambda(it) {
  var tmp1_elvis_lhs = it == null ? null : it.get_id_kntnx8_k$();
  return tmp1_elvis_lhs == null ? 'N/A' : tmp1_elvis_lhs;
}
var NullableTimeZoneRendererClass;
function NullableTimeZoneRenderer() {
  if (NullableTimeZoneRendererClass === VOID) {
    class $ {
      constructor() {
        NullableTimeZoneRenderer_instance = this;
        this.name_1 = 'Time Zone';
        var tmp = this;
        tmp.allTimeZones$delegate_1 = lazy(NullableTimeZoneRenderer$allTimeZones$delegate$lambda);
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_j33pgm_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Select())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          var tmp = _get_allTimeZones__4t4mtu_0(NullableTimeZoneRenderer_getInstance());
          element.bind_64a41i_k$(value, new (Constant())(tmp), NullableTimeZoneRenderer$form$lambda$lambda);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_j33pgm_k$(context, value, module_0);
      }
      view_58y0h7_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_id_kntnx8_k$();
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_58y0h7_k$(context, value, module_0);
      }
      cellForm_pky8ws_k$(context, value, module_0) {
        return this.form_j33pgm_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_pky8ws_k$(context, value, module_0);
      }
      columnWidth_o2bo2p_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_o2bo2p_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableTimeZoneRenderer', VOID, VOID, [Renderer()]);
    NullableTimeZoneRendererClass = $;
  }
  return NullableTimeZoneRendererClass;
}
var NullableTimeZoneRenderer_instance;
function NullableTimeZoneRenderer_getInstance() {
  if (NullableTimeZoneRenderer_instance === VOID)
    new (NullableTimeZoneRenderer())();
  return NullableTimeZoneRenderer_instance;
}
//region block: init
InstantRenderer_instance = new (InstantRenderer())();
NullableInstantRenderer_instance = new (NullableInstantRenderer())();
LocalDateTimeRenderer_instance = new (LocalDateTimeRenderer())();
NullableLocalDateTimeRenderer_instance = new (NullableLocalDateTimeRenderer())();
LocalDateRenderer_instance = new (LocalDateRenderer())();
NullableLocalDateRenderer_instance = new (NullableLocalDateRenderer())();
LocalTimeRenderer_instance = new (LocalTimeRenderer())();
NullableLocalTimeRenderer_instance = new (NullableLocalTimeRenderer())();
//endregion
//region block: exports
export {
  registerDateTimes as registerDateTimeskcii0b01r679,
};
//endregion

//# sourceMappingURL=DateTimeRenderers.mjs.map
